module.exports = __webpack_public_path__ + "static/media/4-b_old.330b68b6.png";